module.exports = __webpack_public_path__ + "static/media/digicel-logo.10008761.png";